import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { onboardProvider } from "@user-management-context/write/application/use-cases/provider-onboarding/onboard-provider";
import { selectProviderOnboarding } from "@user-management-context/write/application/use-cases/provider-onboarding/selectors/provider-onboarding-selectors";
import type { OnboardProviderBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { ProviderOnboarding } from "./provider-onboarding.content";
import { useProviderOnboarding } from "./use-provider-onboarding";

export const ProviderOnboardingContainer = () => {
  const dispatch = useAppDispatch();
  const { processing } = useAppSelector(selectProviderOnboarding);

  useProviderOnboarding();

  const handleSubmit = (body: OnboardProviderBody) => {
    dispatch(onboardProvider(body));
  };

  return <ProviderOnboarding onSubmit={handleSubmit} submitting={processing === "pending"} />;
};
